module.exports = __webpack_public_path__ + "media/images/slider_img_sp_01-55367bd5965c439f60c58334035e7593.png";